import { Building2, BarChart3, CreditCard, FileText, Users, Shield, Zap, Globe } from "lucide-react"

const features = [
  {
    icon: Building2,
    title: "Multi-Business Management",
    description: "Switch between multiple businesses seamlessly. Each with isolated books, settings, and team access.",
  },
  {
    icon: BarChart3,
    title: "Real-time Dashboard",
    description: "Get instant insights into profit, expenses, income, and bank balances with beautiful visualizations.",
  },
  {
    icon: CreditCard,
    title: "Smart Transaction Tracking",
    description: "Record, categorize, and track every financial activity manually or through automated bank feeds.",
  },
  {
    icon: FileText,
    title: "Professional Invoicing",
    description: "Create stunning invoices, track payments, and manage overdue bills with automated reminders.",
  },
  {
    icon: Users,
    title: "Team Collaboration",
    description: "Invite accountants, managers, and team members with role-based access controls.",
  },
  {
    icon: Shield,
    title: "Enterprise Security",
    description: "Bank-level security with multi-tenant architecture ensuring complete data isolation.",
  },
  {
    icon: Zap,
    title: "Automated Reports",
    description: "Generate P&L, balance sheets, and cash flow reports automatically with real-time data.",
  },
  {
    icon: Globe,
    title: "Bank Integration",
    description: "Connect your bank accounts for automatic transaction syncing and reconciliation.",
  },
]

export default function Features() {
  return (
    <section id="features" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">Everything you need to manage your finances</h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            From multi-business management to automated reporting, Accurix provides all the tools modern businesses need
            to stay on top of their finances.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl border border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-500 hover:shadow-lg transition-all duration-200 dark:bg-gray-800"
            >
              <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-600 transition-colors">
                <feature.icon className="h-6 w-6 text-blue-600 group-hover:text-white" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{feature.title}</h3>
              <p className="text-gray-600 dark:text-gray-400">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
